module.exports = __webpack_public_path__ + "img/no.d3c5a0b6.svg";